module.exports = __webpack_public_path__ + "static/karussel4-d7a807ff6be5378b82537cf227911d2d.jpg";